import React from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import webImage from '../../../assets/images/partner/web_image_001.png';
import BackgroundImage from '../../../assets/images/partner/image_003.png';
import { responsiveFont, responsivePaddingHorizontal, responsiveImageSize } from '../../common/responsive.utils';

const Component05 = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    return (
        <>
            {isWeb ? (
                <>
                    <div style={{ background: "#F9FAFF" }}>
                        <div style={{ height: 72 }} />
                        <div style={styles.componentCon_Web}>
                            <p style={styles.titleTxt01_Web}>
                                <span style={styles.titleTxt02_Web}>
                                    상단 노출
                                </span>
                                로 <br />내 매장이 더 눈에 띄게
                            </p>
                            <img src={webImage} style={styles.componentImage_Web} alt="" />
                        </div>

                        <div style={{ height: 72 }} />
                    </div>
                </>
            ) : (
                <>
                    <div style={{ width: "100%", minWidth: "320px", }} >
                        <div style={{ height: "5vh" }} />
                        <p style={styles.grdientTxt02_Mobile}>
                            <span style={styles.titleTxt02_Mobile}>
                                상단 노출
                            </span>
                            로 <br />내 매장이 더 눈에 띄게
                        </p>

                        <div style={{ height: "1.3793vh" }} />

                        <img src={BackgroundImage} alt="" style={styles.componentImg_Mobile} />
                    </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    componentCon_Web: { display: "flex", margin: 0, flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", paddingLeft: responsivePaddingHorizontal(24, 88)},
    componentImage_Web: { width: responsiveImageSize(320, 781), height: responsiveImageSize(472, 880), padding:0 , marginRight: "9.3750vw"},
    titleTxt02_Web: { fontFamily: "Pretendard", fontWeight: 700, fontSize: responsiveFont(22, 40), lineHeight: "140%", letterSpacing: "-3%", color:"#8B4DFF"},
    titleTxt01_Web: { fontFamily: "Pretendard", fontWeight: 700, fontSize: responsiveFont(22, 40), lineHeight: "140%", letterSpacing: "-3%", color:"black"},
  
    grdientTxt02_Mobile: { color: "black", paddingLeft: responsivePaddingHorizontal(24, 88), margin: 0, fontFamily: "'Pretendard'", fontSize: responsiveFont(22, 40), lineHeight: "140%", fontWeight: 700, letterSpacing: "-3%", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", textShadow: "none", },
    titleTxt02_Mobile: { padding: 0, margin: 0, fontSize: responsiveFont(22, 40), fontFamily: "'Pretendard'", fontWeight: 700, letterSpacing: "-3%", lineHeight: "140%", color: "#8B4DFF", whiteSpace: "nowrap", textShadow: "none", },
    componentImg_Mobile: { width: "100vw" },
});

export default Component05;